/**
 * Shared constants and helpers for order lists
 */

/**
 * Standard required fields for all order lists
 */
export const ORDER_REQUIRED_FIELDS = [
	'_id',
	'externalId',
	'externalId2',
	'date',
	'_modified_date',
	'clientId',
	'clientName',
	'clientAddress1',
	'clientAddress2',
	'clientCity',
	'clientState',
	'clientZip',
	'status',
	'origin',
	'numberOfLines',
	'assignedRepName',
	'submitterName',
	'tax',
	'freight',
	'discount',
	'discountType',
	'subtotal',
	'total',
	'totalGP',
	'companyName',
	'alertStatus',
];

/**
 * Required fields for cart lists (no submitterName)
 */
export const CART_REQUIRED_FIELDS = [
	'_id',
	'externalId',
	'externalId2',
	'date',
	'_modified_date',
	'clientId',
	'clientName',
	'clientAddress1',
	'clientAddress2',
	'clientCity',
	'clientState',
	'clientZip',
	'status',
	'origin',
	'numberOfLines',
	'assignedRepName',
	'tax',
	'freight',
	'discount',
	'discountType',
	'subtotal',
	'total',
	'totalGP',
	'companyName',
	'alertStatus',
];

/**
 * Standard sales rep filter rules (conditional based on permissions)
 */
export const SALES_REP_FILTER_RULES = {
	orderSalesRep: {
		defaultValue: [
			{
				id: 'ME',
				label: 'Me',
			},
		],
		applyDefaultIf: {
			type: 'group',
			joiner: 'AND',
			negated: false,
			children: [{ type: 'rule', action: 'orders:view:any', negated: true }],
		},
		lockedIf: {
			type: 'group',
			joiner: 'AND',
			negated: false,
			children: [{ type: 'rule', action: 'orders:view:any', negated: true }],
		},
		hiddenIf: {
			type: 'group',
			joiner: 'AND',
			negated: false,
			children: [{ type: 'rule', action: 'orders:view:any', negated: true }],
		},
	},
};
